import {BaseContainerModel} from "../../base-container.model";
import {bl_wf_user_group_link_RowClass} from "../../../dbschema";

export class WfTeamUserContainerModel extends BaseContainerModel{
  bl_wf_user_group_link: bl_wf_user_group_link_RowClass = new bl_wf_user_group_link_RowClass();
}
